// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__5p4-k","buttons":"SendReceipts_buttons__XY7Mi","email":"SendReceipts_email__1p_8X","bookApptTitle":"SendReceipts_bookApptTitle__1b0zp"};